@for (event of events(); track event) {
  <div
    class="history-event-item"
    [class.event-error]="event.outcome === 'KO' || event.outcome === 'FATAL'"
    [class.event-warning]="event.outcome === 'WARNING'"
  >
    <div class="history-event-date">
      @if (event.parsedData && event.parsedData["Date d'opération"]) {
        {{ event.parsedData["Date d'opération"] | dateTime: 'dd/MM/yyyy | HH:mm:ss' }}
      }
      @if (!event.parsedData || !event.parsedData["Date d'opération"]) {
        {{ event.dateTime | dateTime: 'dd/MM/yyyy | HH:mm:ss' }}
      }
    </div>
    <div class="history-event-title">
      <vitamui-common-event-type-label [key]="event.type"></vitamui-common-event-type-label> -
      <span class="history-event-outcome">{{ event.outcome }}</span>
    </div>
    <div class="history-event-outmessage">
      <vitamui-common-event-type-label [key]="event.outDetail"></vitamui-common-event-type-label>
      @if (event.userIdentifier) {
        <span> {{ 'COMMON.BY_USER' | translate: { userIdentifier: event.userIdentifier } }}</span>
      }
      @if (event.subrogatorIdentifier) {
        <span> ({{ 'COMMON.SUBROGATED_BY' | translate: { subrogatorIdentifier: event.subrogatorIdentifier } }})</span>
      }
      .
    </div>
    @if (checkEventData(event)) {
      <pre class="history-event-details">{{ getEventData(event) }}</pre>
    }
  </div>
}
